// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1onk_","subheader":"ReorderModal_subheader__27EY4","listWrap":"ReorderModal_listWrap__28uRd"};